import React from 'react';

interface IconProps {
    size?: number;
}

function Svg({ size = 18, children }: { size?: number; children: React.ReactNode }) {
    return (
        <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            {children}
        </svg>
    );
}

const stroke = {
    stroke: 'currentColor',
    strokeWidth: 1.6,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const
};

export function MicrophoneIcon({ size }: IconProps) {
    return (
        <Svg size={size}>
            <rect x="6.25" y="2" width="5.5" height="8.75" rx="2.75" {...stroke} />
            <path d="M3.75 8.5C3.75 11.4 6.1 13.75 9 13.75C11.9 13.75 14.25 11.4 14.25 8.5M9 13.75V16" {...stroke} />
        </Svg>
    );
}

export function SendIcon({ size }: IconProps) {
    return (
        <Svg size={size}>
            <path d="M9 14.5V3.5M4.5 8L9 3.5L13.5 8" {...stroke} strokeWidth={1.8} />
        </Svg>
    );
}

export function CloseIcon({ size }: IconProps) {
    return (
        <Svg size={size}>
            <path d="M5 5L13 13M13 5L5 13" {...stroke} />
        </Svg>
    );
}

export function CheckIcon({ size }: IconProps) {
    return (
        <Svg size={size}>
            <path d="M4 9.5L7 12.5L14 5.5" {...stroke} strokeWidth={1.8} />
        </Svg>
    );
}

export function ChevronDownIcon({ size }: IconProps) {
    return (
        <Svg size={size}>
            <path d="M4.5 7L9 11.5L13.5 7" {...stroke} strokeWidth={1.8} />
        </Svg>
    );
}

export function ArrowDownIcon({ size }: IconProps) {
    return (
        <Svg size={size}>
            <path d="M9 3.5V14.5M4.5 10L9 14.5L13.5 10" {...stroke} strokeWidth={1.8} />
        </Svg>
    );
}

export function ChatIcon({ size }: IconProps) {
    return (
        <Svg size={size}>
            <path
                d="M3 4.75C3 3.78 3.78 3 4.75 3H13.25C14.22 3 15 3.78 15 4.75V10.75C15 11.72 14.22 12.5 13.25 12.5H7.25L4.25 15V12.5C3.56 12.5 3 11.94 3 11.25V4.75Z"
                {...stroke}
            />
        </Svg>
    );
}

export function TrashIcon({ size }: IconProps) {
    return (
        <Svg size={size}>
            <path d="M3.5 5H14.5M7 5V3.5C7 3.22 7.22 3 7.5 3H10.5C10.78 3 11 3.22 11 3.5V5" {...stroke} />
            <path d="M5 5.5L5.6 13.6C5.65 14.4 6.1 15 6.9 15H11.1C11.9 15 12.35 14.4 12.4 13.6L13 5.5" {...stroke} />
        </Svg>
    );
}
